import { Currency } from '@/core/currency/interfaces';

const AOA: Currency = {
    name: 'Angolan Kwanza',
    demonym: 'Angolan',
    majorSingle: 'Kwanza',
    majorPlural: 'Kwanza',
    codeNumeric: '973',
    symbol: 'Kz',
    symbolNative: 'Kz',
    minorSingle: 'Centimo',
    minorPlural: 'Centimos',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'AOA',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default AOA;
